import { ChangeDetectionStrategy, Component, OnInit, inject, signal } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';

@Component({
  selector: 'carousel-skeleton',
  templateUrl: './carousel-skeleton.component.html',
  styleUrls: ['./carousel-skeleton.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class CarouselSkeletonComponent implements OnInit {
  private breakpointObserver = inject(BreakpointObserver);
  private spacing = '1.5rem';
  public itemsPerSlide = signal(6);
  public items = signal(Array(6).fill(0));
  public cardWidth = signal(`calc(100% / 6 - ${this.spacing})`);

  ngOnInit(): void {
    this.setResponsiveItemsPerSlide();
  }

  private setResponsiveItemsPerSlide(): void {
    this.breakpointObserver
      .observe([Breakpoints.XSmall, Breakpoints.Small, Breakpoints.Medium, Breakpoints.Large])
      .subscribe((result) => {
        const count = result.breakpoints[Breakpoints.XSmall] ? 2 :
                      result.breakpoints[Breakpoints.Small] ? 4 :
                      result.breakpoints[Breakpoints.Medium] ? 6 : 8;
        this.itemsPerSlide.set(count);
        this.items.set(Array(count).fill(0));
        this.cardWidth.set(`calc(100% / ${count} - ${this.spacing})`);
      });
  }
}